(function () {
  if (window.__countdownRunning) clearInterval(window.__countdownRunning);
  var dataTimeEl = document.querySelector("[data-time]");
  if (!dataTimeEl) return;

  var dataTime = dataTimeEl.dataset.time;
  var countDownDateTime = new Date(dataTime).getTime();

  if (countDownDateTime < new Date().getTime()) {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0);
    tomorrow.setMinutes(0);
    tomorrow.setSeconds(0);
    tomorrow.setMilliseconds(0);
    var currentTime = new Date(dataTime);
    if (tomorrow.getTime() > currentTime.getTime()) {
      countDownDateTime = new Date(tomorrow).getTime();
    }
  }

  const daysValue = document.querySelector("#days");
  const hoursValue = document.querySelector("#hours");
  const minutesValue = document.querySelector("#minutes");
  const secondsValue = document.querySelector("#seconds");

  if (!daysValue || !hoursValue || !minutesValue || !secondsValue) return;

  var x = window.__countdownRunning = setInterval(function () {
    const dateTimeNow = new Date().getTime();
    let difference = countDownDateTime - dateTimeNow;

    daysValue.innerHTML = Math.floor(difference / (1000 * 60 * 60 * 24));
    hoursValue.innerHTML = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    minutesValue.innerHTML = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    secondsValue.innerHTML = Math.floor((difference % (1000 * 60)) / 1000);

    if (daysValue.innerHTML != "00" && daysValue.innerHTML != "0") {
      $('.time-days').addClass('day-hidden');
      $('.countdown-timer-container').addClass('with-days');
    } else {
      $('.time-days').removeClass('day-hidden');
      $('.countdown-timer-container').removeClass('with-days').addClass('without-days');
    }

    if (difference < 0) {
      clearInterval(x);
      daysValue.innerHTML = "00";
      hoursValue.innerHTML = "00";
      minutesValue.innerHTML = "00";
      secondsValue.innerHTML = "00";
    }
  }, 1000);
})();
